// extracted by mini-css-extract-plugin
module.exports = {"followThemeButton":"XOFE8cit","active":"TJY1JAYd"};